import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, FlameIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-carbon" data-id="element-124" data-mp="s9zypgcqn4m7">
      <div className="h-1 w-full bg-lava" aria-hidden="true" data-id="element-125" data-mp="ncq2nhuufupe" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-126" data-mp="neazje4mrpqf">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-lava/50 bg-petrol px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-lava" data-id="element-127" data-mp="3czfl7z4xc761">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-128" data-mp="39aupza1hhgvn" /> {productShortName}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-6 max-w-4xl text-balance font-display text-5xl font-bold leading-[1] text-snow sm:text-6xl lg:text-7xl" data-id="element-129" data-mp="3e8wjkowjcyld">
          Master Your Year of Geothermal Energy Education
          <br data-id="element-130" data-mp="2violwmblv0ck" />
          <span className="text-lava" data-id="element-131" data-mp="2viermmjj2712">in One Afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-132" data-mp="2hjf79r31seap">
          <img src={productImage} alt="Geothermal Energy Teacher Ready: nine volumes and five bonus resources covering fundamentals, geology, drilling, power generation, direct use, sustainability, economics, advanced technologies, and teaching" className="mx-auto w-full drop-shadow-2xl" data-id="element-133" data-mp="s3md82jz5yyd" />
        </motion.div>

        <div className="mt-9" data-id="element-134" data-mp="1b1ffr3qos6v8">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-135" data-mp="1azkv7qjbugro">
            Get your teacher ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-snow" data-id="element-136" data-mp="112pv537eo8ba">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-lava/30 bg-petrol px-3 py-2" data-id="element-137" data-mp="x0l50eg61tte">
              <Icon className="h-3.5 w-3.5 text-lava" aria-hidden="true" data-id="element-138" data-mp="3hr3tc077qj7x" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-muted" data-id="element-139" data-mp="1xavvwffu8055">
          Created by geothermal energy education specialists, for educators worldwide · Updated 2026
        </p>
      </div>
    </section>;
}